import { FadingScrollable } from '@renderer/chat'
import { useSummaryById, useSummaryDate } from '@renderer/chat/hooks'
import { Summary } from '@renderer/windows/components/summary'
import { Skeleton } from '@renderer/components/ui/skeleton'
import { Modal, useModalContext } from '../index'
import { useSummaryActions } from '@renderer/windows/components/summary/hooks/use-summary-actions'

type ChatAboutSummaryButtonProps = {
  dayLabel: string
}

function ChatAboutSummaryButton({ dayLabel }: ChatAboutSummaryButtonProps) {
  const { onStartChat } = useSummaryActions()

  return (
    <Modal.Close variant="primary" onClick={onStartChat}>
      Chat about {dayLabel}
    </Modal.Close>
  )
}

export const SummaryViewModal = () => {
  const { context } = useModalContext('summary-view')
  const { data: summary, isLoading } = useSummaryById(context.summaryId)
  const { dayLabel } = useSummaryDate(summary)

  return (
    <Modal>
      <Modal.Content className="max-h-[90vh] w-full max-w-[min(1200px,90vw)] overflow-hidden">
        <Modal.Header>
          <Modal.Title>{isLoading ? 'Loading...' : dayLabel}</Modal.Title>
        </Modal.Header>
        <FadingScrollable fadeSize="8%">
          <Modal.Body>
            {isLoading ? (
              <div className={'space-y-4'}>
                <Skeleton className="h-6 w-48" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </div>
            ) : summary ? (
              <Summary.Provider summary={summary} isExpanded={true}>
                <Summary.Body containerClassName="pb-4" />
                <Summary.Footer>
                  <ChatAboutSummaryButton dayLabel={dayLabel} />
                </Summary.Footer>
              </Summary.Provider>
            ) : null}
          </Modal.Body>
        </FadingScrollable>
      </Modal.Content>
    </Modal>
  )
}
